import React, { useContext, useState } from 'react';
import store from '../../store';
// Custom components
import Subscribe from './Subscribe';
import Login from './Login';
// Material components
import {
    Button, Dialog
} from '@material-ui/core';
import { AccountBox } from '@material-ui/icons';
// Styles
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    openBtn: {
        color: 'white'
    },
    dialog: {
        width: '95%',
        margin: 0,
        [theme.breakpoints.down('sm')]: {
            maxWidth: 'none',
            margin: 0,
        }
    }
}))

export default function FormDialog() {
    const classes = useStyles();
    const { reducers, modals } = useContext(store);
    const [newAccount, setNewAccount] = useState(true);

    const handleOpen = () => {
        reducers.handleModals('login', modals.login ? false : true);
    };

    const switchStatus = () => {
        setNewAccount(newAccount ? false : true)
    }

    return (
        <div>
            <Button className={classes.openBtn} onClick={handleOpen}>
                <AccountBox />
            </Button>
            <Dialog             
            scroll='body' 
            open={modals.login} 
            onClose={handleOpen} 
            fullWidth
            maxWidth='sm'          
            aria-labelledby="form-dialog-title">
                {newAccount
                    ? <Subscribe switchStatus={switchStatus} handleOpen={handleOpen} />
                    : <Login switchStatus={switchStatus} handleOpen={handleOpen} />}
            </Dialog>
        </div>
    );
}